<ng-template #headerAddAction>
  <button
    type="button"
    class="cabinet-client-page__add-button"
    (click)="onAdd()"
  >
    + {{ 'admin.boxTypes.add' | translate }}
  </button>
</ng-template>

<div class="admin-box-types core-screen">
  @if (!embeddedInCabinetPage()) {
  <div class="title-bar">
    <div class="title-section">
      <h1 class="core-title">{{ 'admin.boxTypes.title' | translate }}</h1>
      @if (displayCount() !== null) {
      <span class="count">{{ displayCount() }}</span>
      }
    </div>
    @if (initialized()) {
    <button class="add-button" (click)="onAdd()">
      + {{ 'admin.boxTypes.add' | translate }}
    </button>
    }
  </div>
  }

  <div class="box-types-list">
    @if (boxTypes()?.data && boxTypes()!.data.length > 0) { @for
    (boxType of boxTypes()!.data; track boxType.id) {
    <div
      class="box-type-card"
      [class.deactivated]="!boxType.is_active"
      [routerLink]="staffCabinetPath + '/box-types/' + boxType.id"
    >
      <div class="card-header">
        <div class="avatar">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <rect
              x="3"
              y="3"
              width="18"
              height="18"
              rx="2"
              stroke="white"
              stroke-width="2"
            />
            <path d="M3 9h18M9 9v12" stroke="white" stroke-width="2" />
          </svg>
        </div>
        <div class="box-type-info">
          <div class="name-row">
            <div class="name">{{ boxType.name }}</div>
            @if (!boxType.is_active) {
            <span class="deactivated-badge"
              >{{ 'warehouse.status.inactive' | translate }}</span
            >
            }
          </div>
          <div class="meta-line">{{ formatDimensions(boxType) }}</div>
          <div class="meta-line">
            {{ 'admin.boxTypes.layers' | translate }}: {{ boxType.layers }}
            <span class="separator">·</span>
            {{ 'admin.boxTypes.maxWeight' | translate }}: {{
            boxType.max_weight_kg }} кг
          </div>
        </div>
      </div>
    </div>
    } } @else if ( !loading() && initialized() && (boxTypes()?.data?.length
    ?? 0) === 0 ) {
    <div class="box-types-empty-state">
      <span>&nbsp;</span>
      <div class="empty-block">
        <img src="/icons/employees-empty.svg" alt="" />
        <p class="empty-text">{{ 'admin.boxTypes.empty' | translate }}</p>
        <p class="empty-hint">{{ 'admin.boxTypes.emptyHint' | translate }}</p>
      </div>
      <lib-cabinet-button
        class="empty-button"
        variant="primary"
        size="lg"
        [fullWidth]="true"
        [text]="'admin.boxTypes.add' | translate"
        [action]="{type: 'action'}"
        (actionEvent)="onAdd()"
      />
    </div>
    } @else if (loading()) {
    <p class="hint" role="status">{{ 'admin.staffQrScan.loading' | translate }}</p>
    }
  </div>
</div>
